import { EVENTS } from '@/utils/constants';
import { Howl } from 'howler';
import { ConfigType, SoundList } from './SoundManager.interface';
import { Sound } from './Sound';
import { GameConfigs } from '@/types/gameConfig';

export class SoundManager {
	GlobalSound: Howl | null = null;
	muteState = false;
	sounds: Record<string, Sound> = {};
	backgrounds: Record<string, Sound> = {};
	GameConfigs: Partial<GameConfigs> = {};

	constructor(gameConfigs: GameConfigs) {
		this.GameConfigs = gameConfigs;
	}

	load(list: SoundList) {
		this.GlobalSound = new Howl({
			src: list.urls,
			sprite: list.sprite,
			autoplay: false,
			loop: false,
			volume: 0.5
		});

		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		window.onblur = () => {
			this.mute();
		};
		window.onfocus = () => {
			this.unMute();
		};
	}

	handleEvent(event: CustomEvent) {
		if (event.type === EVENTS.ERROR_PAGE) {
			window.onblur = null;
			window.onfocus = null;
			return;
		}

		if (event.detail.data.background_music !== undefined) {
			for (const [_, sound] of Object.entries(this.backgrounds)) {
				if (event.detail.data.background_music) {
					sound.volume(1, 100);
				} else {
					sound.volume(0, 100);
				}
			}
		}

		if (event.detail.data.sound_effects !== undefined) {
			for (const [_, sound] of Object.entries(this.sounds)) {
				if (!sound.config.background) {
					if (event.detail.data.sound_effects) {
						sound.volume(1, 100);
					} else {
						sound.volume(0, 100);
					}
				}
			}
		}
	}

	playSoundSwitch(conf: ConfigType) {
		const sound = new Sound(
			conf,
			this.GlobalSound!,
			this.soundCompleted.bind(this)
		);
		sound.play(conf);
	}

	play(conf: ConfigType) {
		const sound = new Sound(
			conf,
			this.GlobalSound!,
			this.soundCompleted.bind(this)
		);

		if (conf.background) {
			if (!this.GameConfigs?.settings?.background_music) {
				conf.muted = true;
				conf.fade = 0;
			} else {
				sound.play(conf);
				this.backgrounds[sound.unique_name] = sound;
			}
		} else {
			if (!this.GameConfigs?.settings?.sound_effects) {
				conf.muted = true;
				conf.fade = 0;
			}
			sound.play(conf);
			this.sounds[sound.unique_name] = sound;
		}
	}

	playBackground(conf: ConfigType) {
		if (!this.GameConfigs?.settings?.background_music) {
			conf.muted = true;
			conf.fade = 0;
		}
		const sound = new Sound(
			conf,
			this.GlobalSound!,
			this.soundCompleted.bind(this)
		);
		sound.play(conf);
		this.backgrounds[sound.unique_name] = sound;
	}

	stop(name: string, fade: number) {
		for (const [_, sound] of Object.entries({
			...this.sounds,
			...this.backgrounds
		})) {
			if (sound.config.name === name) {
				sound.stop(fade);
			}
		}
	}

	mute() {
		Howler.mute(true);
		this.muteState = true;
	}

	unMute() {
		Howler.mute(false);
		this.muteState = false;
	}

	isMuted() {
		return this.muteState;
	}

	soundCompleted(sound: Sound) {
		if (this.sounds[sound.unique_name]) {
			this.sounds[sound.unique_name].destroy();
			delete this.sounds[sound.unique_name];
		}
		if (this.backgrounds[sound.unique_name]) {
			this.backgrounds[sound.unique_name].destroy();
			delete this.backgrounds[sound.unique_name];
		}
	}
}
